module.exports = __webpack_public_path__ + "static/media/nunoPiresDeCarvalho.7880c622.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/nunoPiresDeCarvalho.jpg
// module id = 1378
// module chunks = 1